import { render, staticRenderFns } from "./RatingAverage.vue?vue&type=template&id=54ec9b68&scoped=true&"
import script from "./RatingAverage.vue?vue&type=script&lang=js&"
export * from "./RatingAverage.vue?vue&type=script&lang=js&"
import style0 from "./RatingAverage.vue?vue&type=style&index=0&id=54ec9b68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ec9b68",
  null
  
)

export default component.exports